import Vue from 'vue'
import App from './LandinPage'
import router from './router'
import store from "./store";
import 'bootstrap'
import 'bootstrap/dist/css/bootstrap.min.css'
import './assets/kichwa.css'
import firebase from 'firebase';
import credentials from "@/utils/constants/credentials";
import CodeGeneratorStyles from "@/utils/code-generator-styles";
import VueDashboard from 'vue-dashboard-vd';
import VueModal from '@kouts/vue-modal'
import VueApexCharts from 'vue-apexcharts';
import Vuex from 'vuex';


import '@kouts/vue-modal/dist/vue-modal.css'

let VueScrollTo = require('vue-scrollto');
let VueCodeMirror = require('vue-codemirror'
)

Vue.config.productionTip = false

CodeGeneratorStyles.setStyle(VueCodeMirror,"kichwa")
Vue.use(VueCodeMirror);
Vue.use(VueScrollTo);
Vue.use(VueDashboard);Vue.use(VueApexCharts)
Vue.use(Vuex)
Vue.component('apexchart', VueApexCharts)
Vue.component('Modal', VueModal)
// Initialize Firebase
firebase.initializeApp(credentials.firebaseConfig);

new Vue({
  router,
  store:store,
  components:{
    'Modal': VueModal
  },
  render: h => h(App)
}).$mount('#app')
